module.exports = __webpack_public_path__ + "static/img/gylTT2.8161a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/gylTT2.png
// module id = 464J
// module chunks = 1